<template>
    <div class="resource_subject_add_wrap">
        <div class="header">
            <el-button size="medium" @click="$router.back()">返回</el-button>
            <el-button size="medium" type="primary" @click="execFunc" v-if="!isShowResult" :disabled="isShowLoading">执行</el-button>
            <el-button type="primary" size="medium" @click="exportExcel('#outTable', `sql执行结果.xls`)"   v-if="resultData.length > 0 && isShowResult">导出</el-button>

        </div>
        <div class="resource_subject_box" :style="`height: ${windowHeight - 170}px;`">
            <div class="resource_subject_content">
                <el-form label-width="140px" class="demo-ruleForm" v-show="!isShowResult" v-loading="isShowLoading">
                    <el-form-item label="模板内容" prop="moduleName">
                        <template v-for="(text, index) in textList">
                            <span class="part">{{text}}</span>
                            <span class="part"><el-input style="width: 120px;margin: 0 8px;" v-if="index != textList.length - 1" v-model="argsList[index]"></el-input></span>
                        </template>
                    </el-form-item>
                </el-form>

            </div>
            <div v-show="isShowResult" id="outTable">
                <el-table
                    :height="windowHeight - 245"
                    :data="resultData"
                    style="width: 100%" border
                >
                    <el-table-column
                        v-for="(headerItem, index) in tableHeader"
                        :label="headerItem"
                        align="center" show-overflow-tooltip
                    >
                        <template slot-scope="scope">{{ scope.row[index]}}</template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';

    import {
        sqlToolTemplateQuery,
        sqlTemplateExecute,
        sqlTemplateAgain
    } from '@/api/sql';
    export default {
        name: "sqlTemplateExec",
        mixins: [baseMixin, windowResize],
        data() {
            return {
                id: this.$route.query.id,
                tempContext: '',
                textList: [],
                argsList: [],
                isShowResult: false,
                isShowLoading: false,
                resultData: [],
                tableHeader: [],
                historyId: this.$route.query.historyId
            }
        },
        mounted() {
            if(!!this.historyId) {
                this.isShowLoading = true;
                sqlTemplateAgain({
                    historyId: this.historyId
                })
                    .then(data => {
                        if(data) {
                            this.isShowLoading = false;
                            this.isShowResult = true;
                            this.tableHeader = data[0];
                            this.resultData = data.slice(1);
                        }
                    })
            } else {
                sqlToolTemplateQuery({
                    sqlTemplateId: this.id
                })
                    .then(data => {
                        this.tempContext = data.tempContext;
                        const partList = data.tempContext.split(/\s*{\d}\s*/);
                        const textList = [], argsList = [];
                        partList.forEach((text, index) => {
                            textList.push(text);
                            if(index !== partList.length - 1) {
                                argsList.push('');
                            }
                        });
                        this.textList = textList;
                        this.argsList = argsList;
                    })
            }

        },
        methods: {
            execFunc() {
                if(this.argsList.some(item => item.trim() === '')) {
                    this.$message.error('参数不能为空');
                } else {
                    this.isShowLoading = true;
                    sqlTemplateExecute({
                        params: this.argsList,
                        sqlTemplateId: this.id
                    })
                        .then(data => {
                            if(data) {
                                this.isShowLoading = false;
                                this.isShowResult = true;
                                this.tableHeader = data[0];
                                this.resultData = data.slice(1);
                            }
                        })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import './../../styles/mixin';

    .resource_subject_add_wrap {
        padding: 12px;

        .header {
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }
    }
    .resource_subject_box {
        @include scrollBar;

        .resource_subject_content {
            width: 810px;
            margin: 0 auto;
            padding-top: 20px;

        }
    }
</style>



// WEBPACK FOOTER //
// src/views/sql/sqlTemplateExec.vue